import React from "react";
import PropTypes from "prop-types";
import Grid from "../Grid/Grid";
import Utils from "../../helpers/Utils";
import ImagesLoaded from "react-images-loaded";

class ImageMeasurer extends React.Component {
  static propTypes = {
    items: PropTypes.array,
  };
  constructor(props) {
    super(props);
    this._sortBy = this._sortBy.bind(this);
    this._setImageDimensions = this._setImageDimensions.bind(this);
  }

  state = {
    shouldRenderGrid: false,
    itemsWithDimensions: [],
    firstPage: true,
  };

  items = [];
  scrollPosition = 0;
  showMoreIsClicked = false;

  _measureImagesWhenReady = () => {
    const imagesReady = this.items.every(function (item) {
      return item.img && item.img.complete;
    });
    if (imagesReady) {
      this._setImageDimensions();
    }
  };

  _clickThumb = (id) => {
    this.props.clickThumb(id);
  };

  _sortBy = (by) => {
    this.props.sortBy(by);
  };
  _showMore = (e) => {
    this.props.showMore();
    // save scroll position
    this.scrollPosition = window.pageYOffset;
    this.showMoreIsClicked = true;
  };

  _scrollPosIsSet = (e) => {
    this.showMoreIsClicked = false;
  };

  _prepareImages = (items) => {
    return items.map((item) => {
      return Object.assign(item.item, {
        image: {
          src: item.img.src,
          height: item.img.offsetHeight,
          width: item.img.offsetWidth,
        },
      });
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.shouldRenderGrid) {
      this.setState({
        shouldRenderGrid: false,
        firstPage: false,
      });
    }
  }

  _setImageDimensions() {
    if (!this.state.shouldRenderGrid) {
      this.setState({
        itemsWithDimensions: this._prepareImages(
          this.items.filter((item) => {
            return !!item.img;
          })
        ),
        shouldRenderGrid: true,
      });
    }
  }

  render() {
    let styles = { opacity: 0 };
    return (
      this.props.gridItems.length > 0 &&
      (this.state.shouldRenderGrid ? (
        <Grid
          items={this.props.items}
          gridItems={this.state.itemsWithDimensions}
          clickThumb={this._clickThumb}
          sortBy={this._sortBy}
          showMore={this._showMore}
          sortedBy={this.props.sortedBy}
          cmsData={this.props.cmsData}
          gridTitle={this.props.gridTitle}
          setScrollPos={this.showMoreIsClicked}
          scrollPosition={this.scrollPosition}
          scrollPosIsSet={this._scrollPosIsSet}
          noDateText={this.props.noDateText}
        />
      ) : (
        <div className="gallery-loading-container">
          <img
            src="/Web/FrontEndR/assets/gfx/loader.gif"
            // src="https://cdn-images-1.medium.com/max/1600/1*9EBHIOzhE1XfMYoKz1JcsQ.gif" width="256" height="256"
            alt={this.props.cmsData.waitAltText}
            className={this.showMoreIsClicked ? "show-more-clicked" : null}
          />
          <ImagesLoaded
            style={styles}
            elementType={"div"}
            className={"gallery-loading"}
            done={this._setImageDimensions}
          >
            {this.props.gridItems.map((item, index) => {
              let url = Utils.image.getUrl(item, 400);
              return (
                <img
                  alt={item["artifact.ingress.title"]}
                  src={url}
                  key={index}
                  ref={(img) => (this.items[index] = { img, item })}
                />
              );
            })}
          </ImagesLoaded>
        </div>
      ))
      // ))
    );
  }
}

export default ImageMeasurer;
